/* ========================================================================= */
/* reCAPTCHA site key */
/* ========================================================================= */

let RECAPTCHA_SITE_KEY = null;

/**
 * Set global variable RECAPTCHA_SITE_KEY
 * @param {string} key reCAPTCHA site key
 */
export const setRecaptchaSiteKey = (key) => {
    RECAPTCHA_SITE_KEY = key;
};

/**
 * Get global variable RECAPTCHA_SITE_KEY
 * @return {string | null}
 */
export default () => {
    return RECAPTCHA_SITE_KEY;
};
